


import React, { useEffect, useState, } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { Button, TextField, Select, MenuItem, FormControl, InputLabel, Box, Stack, Grid2, Grid } from "@mui/material";
import axiosInstance from "../../../axios/axios";
import ScheduleForm from "../newScan/ScheduleForm";
import dayjs, { Dayjs } from "dayjs";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import { CircularProgress,  } from '@mui/material';




import AddScheduleForm from './AddScheduleForm';
import AssetTable from './AssetTable';
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setEdit } from "../myScan/Schedule_Slice";



interface FrequencyOptions {
    frequency?: any;
    timeZone?: any;
    date?: any;
    timeOptions?: any;
    Days?: any;
}

const ScheduleMain = () => {
    const dispatch = useDispatch()
    const [scanName, setScanName] = useState("");
    const [selectedFrequency, setSelectedFrequency] = useState<any | null>(null);
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
    const [date, setDate] = useState<string>("");
    const [selectedDay, setSelectedDay] = useState<any | null>(null);
    const [selectedTime, setSelectedTime] = useState<any | null>(null);
    const [addedAssets, setAddedAssets] = useState<any[]>([]);
    const [removeAssets, setRemoveAssets] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    // const [removeAssets, setRemoveAssets] = useState<any[]>([
    //   { id: '1', name: '07SW5476E', type: 'Switch', vendor: 'CISCO', region: 'Region \\ Country \\ State' },
    //   { id: '2', name: '07SW5476E', type: 'Switch', vendor: 'CISCO', region: 'Region \\ Country \\ State' },
    //   // Add more assets as needed
    // ]);


    const [isScheduled, setIsScheduled] = useState<boolean>(false);
    const [scheduleOptions, setScheduleOptions] = useState<FrequencyOptions>(
        {}
    );
    const { scan_uuid } = useParams();
    const [scanUuid, setScanUuid] = useState<string | null>(scan_uuid || null);

    useEffect(() => {
        setScanUuid(scan_uuid || null); // Set the scanUuid state whenever scan_uuid changes
    }, [scan_uuid])

    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (scanUuid) {
    //             dispatch(setEdit({ edit: true, schedule_scan_id: scanUuid })); // Set the edit state in Redux

    //         } else {
    //             dispatch(setEdit({ edit: false, schedule_scan_id: null })); // Set the edit state in Redux
    //         }
    //         loadFrequency();
    //         const queryParams: any = {
    //             scheduled_flag: 'false',  // Static query parameter
    //         };
    //         const response = await axiosInstance.get('securityscan/scheduled-assets', { params: queryParams });
    //         console.log(response.data.data.device_list);
    //         const updatedRemoveAssets = response.data.data.device_list.map((device: any) => ({
    //             ...device,  // Spread existing device properties
    //             isChecked: false,  // Add the `isChecked` field with `false` value
    //         }));
    //         console.log(updatedRemoveAssets);
    //         setRemoveAssets(updatedRemoveAssets); // Set the assets not attached to scan
    //         if (scanUuid !== null && scanUuid !== undefined) {
    //             queryParams.scheduled_flag = true;
    //             queryParams.schedule_scan_id = scanUuid;
    //             const response = await axiosInstance.get(`securityscan/scheduled-assets`, { params: queryParams });
    //             console.log(response.data.data);
    //             const updatedRemoveAssets = response.data.data.device_list.map((device: any) => ({
    //                 ...device,  // Spread existing device properties
    //                 isChecked: false,  // Add the `isChecked` field with `false` value
    //             }));
    //             setAddedAssets(updatedRemoveAssets); // Set the assets attached to scan
    //             queryParams.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    //             const res = await axiosInstance.get(`securityscan/schedule-info`, { params: queryParams });
    //             console.log(res.data.data);
    //             //setAddedAssets(response.data.data.device_list);
    //             const scheduleData = res.data.data;
    //             // Map API response to state variables
    //             setSelectedFrequency(scheduleData.frequency_id); // Frequency ID
    //             if(scheduleData.date!=null) {
    //             setSelectedDate(dayjs(scheduleData.date, "DD-MM-YYYY")); // Date
    //             }
    //             //setSelectedTime(scheduleData.time); // Time
    //             const formattedTime = dayjs(scheduleData.time, "HH:mm:ss").format("hh:mm A");
    //             //console.log("Formatted Time:", formattedTime);
    //             setSelectedTime(formattedTime); // Set formatted time
    //             setScanName(scheduleData.schedule_name); // Scan name


    //             if (scheduleData.frequency === "Weekly" && scheduleData.day) {
    //                 setSelectedDay(scheduleData.day); // Set day if frequency is weekly
    //             }

    //         }


    //     };

    //     fetchData();
    // }, [scanUuid]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true); // Start loading
                if (scanUuid) {
                    dispatch(setEdit({ edit: true, schedule_scan_id: scanUuid }));
                } else {
                    dispatch(setEdit({ edit: false, schedule_scan_id: null }));
                }
                await loadFrequency();
                
                const queryParams: any = { scheduled_flag: 'false' };
                const response = await axiosInstance.get('securityscan/scheduled-assets', { params: queryParams });
                const updatedRemoveAssets = response.data.data.device_list.map((device: any) => ({
                    ...device,
                    isChecked: false,
                }));
                setRemoveAssets(updatedRemoveAssets);
    
                if (scanUuid) {
                    queryParams.scheduled_flag = true;
                    queryParams.schedule_scan_id = scanUuid;
    
                    const response = await axiosInstance.get('securityscan/scheduled-assets', { params: queryParams });
                    const updatedAddedAssets = response.data.data.device_list.map((device: any) => ({
                        ...device,
                        isChecked: false,
                    }));
                    setAddedAssets(updatedAddedAssets);
    
                    queryParams.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    const res = await axiosInstance.get('securityscan/schedule-info', { params: queryParams });
                    const scheduleData = res.data.data;
    
                    setSelectedFrequency(scheduleData.frequency_id);
                    if (scheduleData.date) {
                        setSelectedDate(dayjs(scheduleData.date, "DD-MM-YYYY"));
                    }
                    const formattedTime = dayjs(scheduleData.time, "HH:mm:ss").format("hh:mm A");
                    setSelectedTime(formattedTime);
                    setScanName(scheduleData.schedule_name);
    
                    if (scheduleData.frequency === "Weekly" && scheduleData.day) {
                        setSelectedDay(scheduleData.day);
                    }
                }
            } catch (err) {
                console.error("Error loading data", err);
            } finally {
                setLoading(false); // Stop loading
            }
        };
    
        fetchData();
    }, [scanUuid]);
    
    
    // Added addedAssets and removeAssets to dependencies
    console.log("Added Assets:", addedAssets);
    console.log("Removed Assets:", removeAssets);

    const handleTimeChange = (event: any) => {
        setSelectedTime(event.target.value);
    };
    const handleScanNameChange = (newScanName: string) => {
        setScanName(newScanName);  // Update the state with the new value
    };

    const [parentTimeOptions, setParentTimeOptions] = useState(
        scheduleOptions?.timeOptions
    );

    const handleAddAsset = (asset: any) => {
        // Remove from removeAssets and add to addedAssets
        setRemoveAssets(prevRemoveAssets => prevRemoveAssets.filter(item => item.id !== asset.id));
        asset.isChecked = false;
        setAddedAssets(prevAddedAssets => [...prevAddedAssets, asset]);
    };

    const handleRemoveAsset = (asset: any) => {
        // Remove from addedAssets and add to removeAssets
        setAddedAssets(prevAddedAssets => prevAddedAssets.filter(item => item.id !== asset.id));
        asset.isChecked = false;
        setRemoveAssets(prevRemoveAssets => [...prevRemoveAssets, asset]);
    };

    const loadFrequency = async (): Promise<void> => {
        // Your logic here
        try {
            const response = await axiosInstance.get(
                `securityscan/schedule-frequency`
            );
            setScheduleOptions({
                frequency: response.data.data.frequency,
                Days: response.data.data.weekly,
                timeOptions: timeOptions(),
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            });
            setParentTimeOptions(timeOptions());
            //const frequencyList = response.data || [];
            //setScheduleFrequency(frequencyList); // Assuming you have state for this
        } catch (error) {
            console.error("Error fetching schedule frequency: ", error);
        }
    };

    const isOtherFrequency = () => {
        console.log("isOtherFrequency called");
        console.log("Selected Frequency:", selectedFrequency);
        console.log("Schedule Options:", scheduleOptions);
        console.log("isWeekly:", isWeekly());
        console.log("isHourly:", isHourly());
        console.log("selectedDay:", selectedDay);
        console.log("selectedDate:", selectedDate);
        return selectedFrequency && !isWeekly() && !isHourly();
    };

    const isWeekly = () => {
        return (
            scheduleOptions?.frequency?.find((f: any) => f.id === selectedFrequency)
                ?.name === "Weekly"
        );
    };

    const isHourly = () => {
        const hourly = scheduleOptions?.frequency?.find((f: any) => f.id === selectedFrequency)
                ?.name === "Hourly"
        const daily =  scheduleOptions?.frequency?.find((f: any) => f.id === selectedFrequency)
                ?.name === "Daily"
        if(hourly || daily) {
            return true; 
        } else {
            return false; 
        }
    };

    const timeOptions = (formattedTime?: string): string[] => {
        let timeOptions: string[] = [];
        let startHour = 0;
        let startMinute = 0;
        let startSecond = 0;

        // Parse the formattedTime to determine the starting point
        if (formattedTime) {
            const timeParts = formattedTime.split(":");
            startHour = parseInt(timeParts[0], 10);
            startMinute = parseInt(timeParts[1], 10);
            if (timeParts.length > 2) {
                startSecond = parseInt(timeParts[2], 10);
            }
        }

        // Generate time options from the specified starting point
        for (let hour = startHour; hour < 24; hour++) {
            for (
                let minute = hour === startHour ? startMinute : 0;
                minute < 60;
                minute++
            ) {
                const period = hour < 12 ? "AM" : "PM";
                const adjustedHour = hour % 12 === 0 ? 12 : hour % 12;
                const formattedHour = String(adjustedHour).padStart(2, "0");
                const formattedMinute = String(minute).padStart(2, "0");
                const time = `${formattedHour}:${formattedMinute} ${period}`;
                timeOptions.push(time);
            }
        }

        // Append 12:00 AM at the end of the list if not included
        if (!timeOptions.includes("12:00 AM")) {
            timeOptions.push("12:00 AM");
        }

        return timeOptions;
    };


    const handleFrequencyChange = (event: any) => {
        const value = event.target.value;
        setSelectedFrequency(value);
        // Reset date and day when frequency changes
        setSelectedDate(null);
        setSelectedDay(null);
        setSelectedTime(null);
    };

    const assets = Array(5).fill({
        name: "07SW54/76E",
        type: "Switch",
        vendor: "CISCO",
        region: "Region | Country | State",
    });

    const handleEdit = () => {
        console.log("Edit button clicked");
    };

    const handleCancel = async () => {
        if (scanUuid) {
            let req: any = {};
            req.schedule_id = scanUuid;
            try {
                const response = await axiosInstance.post(
                    "securityscan/cancel-schedule",
                    req
                );
                console.log("Response:", response.data);
                toast(response.data.message, { type: "success" });
                navigate("/on-premises/scans"); // Redirect to the desired page after saving
            } catch (error: any) {
                toast.error(
                    error.response.data
                        ? error.response.data.message
                        : "Something went wrong",
                    { type: "error" }
                );
            }
        }


        console.log("Cancel Schedule button clicked");
    };


    const handleDateChange = (newDate: dayjs.Dayjs | null) => {
        console.log(newDate?.year());

        // Convert Dayjs object to JS Date
        //const dateAsJS = newDate.toDate();
        setSelectedDate(newDate);
        const day = newDate?.date(); // Get the day of the month
        const month = newDate ? newDate.month() + 1 : 0; // Get the month (1-based, not 0-based)
        const year = newDate?.year(); // Get the year and make it negative

        const formatted = `${day}-${month}-${year}`;
        setDate(formatted);

        const today = dayjs().startOf("day"); // Get today's date without time
        const isToday = newDate ? newDate.isSame(today, "day") : false; // Compare only the date, not the time

        if (isToday) {
            // If the selected date is today's date, generate new time options
            const updatedTimeOptions = generateTimeOptionsFromNow();
            setParentTimeOptions(updatedTimeOptions);
            setSelectedTime(updatedTimeOptions[0]); // Set the first time option as selected
        } else {
            // If it's not today's date, keep the original time options
            setParentTimeOptions(scheduleOptions?.timeOptions || []);
            setSelectedTime(scheduleOptions?.timeOptions[0]); // Set the first time option as selected
        }
    };

    const generateTimeOptionsFromNow = (): string[] => {
        const timeOptions: string[] = [];
        const currentTime = new Date();
        currentTime.setMinutes(currentTime.getMinutes() + 5);

        let startHour = currentTime.getHours();
        let startMinute = currentTime.getMinutes();

        for (let hour = startHour; hour < 24; hour++) {
            for (
                let minute = hour === startHour ? startMinute : 0;
                minute < 60;
                minute++
            ) {
                const period = hour < 12 ? "AM" : "PM";
                const formattedHour = (hour % 12 || 12).toString(); // Convert hour to 12-hour format
                const formattedMinute = ("0" + minute).slice(-2); // Ensure two-digit format
                const time = `${formattedHour}:${formattedMinute} ${period}`;
                timeOptions.push(time);

                // Stop at 11:59 PM
                if (hour === 23 && minute === 59) {
                    return timeOptions;
                }
            }
        }

        return timeOptions;
    };

    const handleDayChange = (event: any) => {
        setSelectedDate(null); // Reset selected date when day changes
        setSelectedDay(event.target.value);
    };
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const AddAssetsOnClick = (selectedRows: any[]) => {
        // Move selected assets from removeAssets to addedAssets
        const selectedAssets = removeAssets.filter((asset: any) =>
            selectedRows.some((selectedRow: any) => selectedRow.id === asset.id)  // Check if the asset id is in selectedRows
        );

        // Set isChecked to false for selected assets before adding them to addedAssets
        const updatedSelectedAssets = selectedAssets.map((asset) => ({
            ...asset,
            isChecked: false,  // Set isChecked to false
        }));

        // Add selected assets to addedAssets
        setAddedAssets((prevAssets) => [
            ...prevAssets,
            ...updatedSelectedAssets,
        ]);
        console.log("Updated Added Assets: on click", addedAssets);

        // Remove selected assets from removeAssets
        setRemoveAssets((prevAssets) =>
            prevAssets.filter((asset) => !selectedRows.some((selectedRow) => selectedRow.id === asset.id))  // Filter out the selected assets
        );
        console.log("Updated Remove Assets: on click", removeAssets);

        // Clear selection
        setSelectedRows([]);
    };




    const RemoveAssetsOnClick = (selectedRows: any[]) => {
        // Move selected assets from addedAssets to removeAssets
        const selectedAssets = addedAssets.filter((asset: any) =>
            selectedRows.some((selectedRow: any) => selectedRow.id === asset.id)  // Check if the asset id is in selectedRows
        );

        // Set isChecked to false for selected assets before adding them to removeAssets
        const updatedSelectedAssets = selectedAssets.map((asset) => ({
            ...asset,
            isChecked: false,  // Set isChecked to false
        }));

        // Add selected assets to removeAssets
        setRemoveAssets((prevAssets) => [
            ...prevAssets,
            ...updatedSelectedAssets,
        ]);
        console.log("Updated Remove Assets: on click", removeAssets);

        // Remove selected assets from addedAssets
        setAddedAssets((prevAssets) =>
            prevAssets.filter((asset) => !selectedRows.some((selectedRow) => selectedRow.id === asset.id))  // Filter out the selected assets
        );
        console.log("Updated Added Assets: on click", addedAssets);

        // Clear selection
        setSelectedRows([]);
    };






    // const convertTo24HourFormat = (time: string) => {
    //     // Use dayjs to parse the time and convert it to 24-hour format
    //     return dayjs(time, 'hh:mm A').utc().format('HH:mm');
    // };

    const convertToUtcTime = (time: string) => {
    const today = dayjs().format("YYYY-MM-DD");
    const dateTimeString = `${today} ${time}`;
    const utcTime = dayjs(dateTimeString, "YYYY-MM-DD hh:mm A").utc().format("HH:mm");
    return utcTime;
    };
    const handleSave = async () => {
        console.log("Save button clicked");
        console.log("Selected Frequency:", selectedFrequency);
        console.log("Selected Date:", selectedDate);
        console.log("Selected Day:", selectedDay);
        console.log("Selected Time:", selectedTime);
        console.log("Scan Name:", scanName);
        console.log("Added Assets:", addedAssets);
        console.log("Removed Assets:", removeAssets);
        console.log("Scan UUID:", scanUuid);

        const selectedTime24Hour = convertToUtcTime(selectedTime);
        // Prevent saving a schedule with no attached assets
        if (!addedAssets || addedAssets.length === 0) {
            toast.error("Please add at least one asset before scheduling");
            return;
        }
        console.log("Selected Time (24-hour format):", selectedTime24Hour);
        let formattedDate = ""; 
        if (selectedDate) {
            const day = selectedDate.date(); // Day of the month
            const month = selectedDate.month() + 1; // Month (1-based)
            const year = selectedDate.year(); // Year
          
             formattedDate = `${day}-${month}-${year}`;
            console.log("Formatted Date:", formattedDate);
          
            setDate(formattedDate);
          }
        const removed_devices = removeAssets.map((asset) => asset.id);
        const device_ids: any = addedAssets.map((asset) => asset.id);

        const frequencyObj = scheduleOptions?.frequency?.find((f: any) => f.id === selectedFrequency);
        const isHourlyFreq = frequencyObj?.name === "Hourly";

        let req: any = {};
        if (scanUuid) {
            req.schedule_scan_id = scanUuid;  // Attach the schedule ID for editing
        }
        req.frequency_id = selectedFrequency;
        
        if (!isHourlyFreq) {
            req.date = formattedDate;
        }
        
        req.time = selectedTime24Hour;
       req.day = selectedDay || ""; 
        req.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        req['device_ids'] = device_ids;
        req['removed_devices'] = removed_devices;
        req.schedule_name = scanName;
        
        console.log("[Schedule Main Debug] Prepared payload (sending):", req);

        try {
            let response = null
            if(scanUuid){
                 response = await axiosInstance.put(
                    "securityscan/schedule-scan",
                    req
                );

            } else{
                 response = await axiosInstance.post(
                    "securityscan/schedule-scan",
                    req
                );
            }
            

            // If successful, show success toast and navigate
            console.log("Response:", response.data);
            if(response.data){
                toast(response.data.message, { type: "success" });

            // Navigate to the desired page after saving
            // Make sure the navigate function is called here
            navigate("/on-premises/scans", { state: { switchOn: true } });  // Adjust the path to your requirement

            }
            

        } catch (error: any) {
            // Handle error and display toast message
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
        }
    };


    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>

         <div
            // component="main" 
            style={{
                flexGrow: 1,
                overflow: 'none',
                height: "calc(100vh - 104px)",
                padding: 4,
            }}
        >
            <Box  sx={{ mb: 3, borderRadius: '8px', backgroundColor: '#fff' }}>
                <AddScheduleForm
                    isScheduled={isScheduled}
                    selectedFrequency={selectedFrequency}
                    handleFrequencyChange={handleFrequencyChange}
                    scheduleOptions={scheduleOptions}
                    isOtherFrequency={isOtherFrequency}
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                    isWeekly={isWeekly}
                    selectedDay={selectedDay}
                    handleDayChange={handleDayChange}
                    isHourly={isHourly}
                    selectedTime={selectedTime}
                    handleTimeChange={handleTimeChange}
                    parentTimeOptions={parentTimeOptions}
                    scan_uuid={scanUuid}
                    handleSave={handleSave}
                    handleCancel={handleCancel}
                    handleEdit={handleEdit}
                    scanName={scanName}
                    handleScanNameChange={handleScanNameChange}
                    hasAddedAssets={addedAssets.length > 0}
                />
            </Box>

            <Grid container spacing={3} sx={{ height: 'calc(100vh - 280px)' }}>
                <Grid item xs={12} md={6} sx={{ height: '100%' }}>
                    <AssetTable title="Assets attached to scan" assets={addedAssets} ButtonLabel="Remove Assets" ButtonColor='secondary' ButtonONClick={RemoveAssetsOnClick} removeIcon={true} handleRemoveAsset={handleRemoveAsset} setSelectedRows={selectedRows} />
                </Grid>
                <Grid item xs={12} md={6} sx={{ height: '100%' }}>
                    <AssetTable title="Assets not attached to scan" assets={removeAssets} ButtonLabel='Add Asset' ButtonColor='primary' ButtonONClick={AddAssetsOnClick} removeIcon={false} handleAddAsset={handleAddAsset} setSelectedRows={selectedRows} />
                </Grid>
            </Grid>
        </div>
        </>
       
    );
};

export default ScheduleMain;